const sc = 'v1/sc';
const scV4 = 'v4/sc';

export const API_ROUTES = {
  GET_SC_DASHBOARD: `${sc}/get-sc-cblicensingcode`,
  GET_SC_DASHBOARD_V4: `${scV4}/get-sc-cb-licensing-code-v4`,
  GET_SC_HISTORICAL_DASHBOARD:`${sc}/get-sc-dtrackit-transactions`,
  GET_SC_HISTORICAL_DASHBOARD_V4:`${scV4}/get-sc-dtrackit-transactions-v4`,
  GET_SC_DETAILS: `${sc}/get-sc-details`,
  GET_SC_DETAILS_V4: `${scV4}/get-sc-details-v4`,
  POST_SC_DETAILS: `${sc}/post-sc-details`,
  POST_SC_DETAILS_V4: `${scV4}/post-sc-details-v4`,
  GET_FACILITY_DETAILS: `${sc}/list-facility-details`,
  GET_FACILITY_LIST_DETAILS_V4: `${scV4}/get-list-facility-details-v4`,
  GET_FACILITY_DETAILS_NEW: `${sc}/get-facility-details-new`,
  GET_FACILITY_DETAILS_V4: `${scV4}/get-facility-details-v4`,
  CREATE_FACILITY_DETAILS: `${sc}/post-facility-details-new`,
  CREATE_FACILITY_DETAILS_V4: `${scV4}/post-facility-details-v4`,
  GET_PRODUCT_FACILITY_DETAILS: `${sc}/list-facility-product-details`,
  GET_PRODUCT_FACILITY_DETAILS_NEW: `${sc}/get-facility-product-details-new`,
  GET_PREVIEW_SC:`${sc}/get-preview-sc-details`,
  POST_FACILITY_PRODUCT_DETAILS: `${sc}/post-facility-product-details-new`,
  CO_DETAILS: `${sc}/post-co-details`,
  CO_DETAILS_V4: `${scV4}/post-co-details-v4`,
  GET_CO_DETAILS: `${sc}/get-co-details`,
  GET_CO_DETAILS_V4: `${scV4}/get-co-details-v4`,
  SAVE_SC:`${sc}/save-data`,
  SAVE_SC_V4:`${scV4}/post-save-api-v4`,
  SUBMIT_SC:`${sc}/post-declaration-submit-details`,
  SUBMIT_SC_V4:`${scV4}/post-declaration-submit-details-v4`,
  GET_DECLARATION_JSON_DETAILS:`${sc}/get-json`,
  GET_CO_DTRACKIT_NAME:`${sc}/get-co-name`,
  GET_CO_DTRACKIT_NAME_V4:`${scV4}/get-co-name-v4`,
  GET_CO_HISTORIC_NAME:`${sc}/get-dtrackit-co-name`,
  GET_CO_HISTORIC_NAME_V4:`${scV4}/get-dtrackit-co-name-v4`,
  DELETE_API:`${sc}/delete-api-new`,
  EDIT_SC_DETAILS:`${sc}/edit-sc`,
  EDIT_SC_DETAILS_V4:`${scV4}/edit-sc-v4`,
  GET_SC_NO:`${sc}/get-sc-no`,
  GET_SC_NO_V4:`${scV4}/get-sc-no-v4`,
  GET_DISABLE_TABS:`${sc}/get-disable-tabs`,
  GET_DISABLE_TABS_V4:`${scV4}/get-disable-tabs-v4`,
  SC_PREVIEW:`${sc}/get-preview-sc-details`,
  GET_WORD_DOC: `${sc}/sc-generate-word`,
  GET_SC_CANCEL_AMEND:`${sc}/cancel-amend`,
  GET_SC_CANCEL_AMEND_V4:`${scV4}/cancel-amend-v4`,
  POST_RAW_MATERIAL_DETAILS_V4: `${scV4}/post-raw-material-details-v4`,
  GET_RAW_MATERIAL_DETAILS_V4: `${scV4}/get-raw-material-details-v4`,
  GET_PRODUCT_DETAILS_V4: `${scV4}/get-product-details-v4`,
  POST_PRODUCT_DETAILS_V4: `${scV4}/post-product-details-v4`,
  GET_COMPONENT_DETAILS_V4: `${scV4}/get-component-details-v4`,
  POST_COMPONENT_DETAILS_V4: `${scV4}/post-component-details-v4`,
  GET_PRODUCT_CLAIMS_DETAILS_V4: `${scV4}/get-product-claims-details-v4`,
  POST_PRODUCT_CLAIMS_DETAILS_V4: `${scV4}/post-product-claims-details-v4`,
  DELETE_API_V4: `${scV4}/delete-api-v4`,
  // New v4 API routes for download and preview
  GET_WORD_DOC_V4: `${scV4}/sc-generate-word-v4`,
  GET_PREVIEW_SC_V4: `${scV4}/get-preview-sc-details-v4`,
  // Product Category Information API routes
  GET_PRODUCT_CATEGORY_INFORMATION_V4: `${scV4}/get-product-category-v4`,
  POST_PRODUCT_CATEGORY_INFORMATION_V4: `${scV4}/post-product-category-v4`,
  // Product Detail Information API routes
  GET_PRODUCT_DETAIL_INFORMATION_V4: `${scV4}/get-product-details-v4`,
  POST_PRODUCT_DETAIL_INFORMATION_V4: `${scV4}/post-product-details-v4`,
  GET_CB_CODE_FOR_TE_ID:`${scV4}/get-dtrackit-teId-cb-code-v4`
};
